import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import PrivateRoute from "src/components/PrivateRoute";
import * as ROUTES from "src/constants/routes";
import { Dashboard } from "src/pages/Dashboard";
import Login from "src/pages/Login";
import { AuthProvider } from "src/contexts/AuthContext";
import CerificatesClient from "src/pages/CertificatesClient";
import Consulta from "src/pages/CertificateSearch";

const AppRoutes: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route
            path={ROUTES.DASHBOARD}
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route path={ROUTES.LOGIN} element={<Login />} />
          <Route path="/:hash" element={<CerificatesClient />} />

          <Route path="*" element={<Navigate to={ROUTES.LOGIN} replace />} />
          <Route path={ROUTES.CONSULTA} element={<Consulta />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AppRoutes;
